/**
 * Base de données des numéros de lot et normes des matériaux dentaires
 * Utilisé pour la traçabilité sur les documents générés (fiche de travail, bon de livraison, facture, fiche patient)
 * Conforme Règlement Européen (UE) 2017/745 (MDR) Dispositifs Médicaux sur Mesure (DMSM)
 * 
 * Source officielle: dossier "numero de lot" du laboratoire (fiches fabricants et tableaux matières)
 */

const materialLotData = {
    // ===== ZIRCONE (Aidite) =====
    ZIRCONIA: {
        disc: { 
            name: 'Disque Zircone (Multilayer / Monochrome)', 
            manufacturer: 'Aidite', 
            ce: 'CE SX 60114386 0001', 
            iso: 'ISO 6872', 
            lot: 'AIDITE-W210207SH7',
            composition: 'ZrO2+HfO2 95%, Y2O3 5%, Al2O3 <1%'
        },
    },

    // ===== CÉRAMIQUE DE STRATIFICATION POUR ZIRCONE (Noritake CERABIEN ZR) =====
    // Utilisée UNIQUEMENT pour la Zircone Stratifiée (PFZ), JAMAIS pour la Full Zircone monolithique
    NORITAKE_PORCELAIN: {
        manufacturer: 'Noritake (Japan)',
        composition: 'CERABIEN ZR',
        ce: 'CE0124',
        iso: 'ISO 6872',
        defaultLot: 'EGIUB',
        shades: {
            A1: { lot: 'EGYEY' },
            A2: { lot: 'EGIUB' },
            A3: { lot: 'EGIUD' },
            'A3.5': { lot: 'EFUVD' },
            A4: { lot: 'DVBXV' },
            B1: { lot: 'Z01ZN7' },
            B2: { lot: 'EGIUB' },
            B3: { lot: 'EGIUD' },
            B4: { lot: 'EFUVD' },
            C1: { lot: 'EGYEY' },
            C2: { lot: 'EGIUB' },
            C3: { lot: 'EGIUD' },
            C4: { lot: 'EFUVD' },
            D2: { lot: 'EGIUB' },
            D3: { lot: 'EGIUD' },
            D4: { lot: 'EFUVD' },
        }
    },

    // ===== ALLIAGE COBALT-CHROME (Co-Cr) POUR COURONNES COULÉES & INLAY CORES =====
    COCR_CROWN: {
        alloy: { 
            name: 'Alliage Co-Cr non précieux (sans Be ni Ni)', 
            manufacturer: 'Bego / Argen', 
            ce: 'CE542249', 
            iso: 'ISO 22674', 
            lot: 'Co-cr-20090301',
            composition: 'Co-Cr Beryllium and Nickel free'
        }
    },

    // ===== ALLIAGE COBALT-CHROME (Co-Cr) POUR CCP / STELLITE (CHÂSSIS COULÉ PARTIEL) =====
    COCR_FRAMEWORK: {
        alloy: { 
            name: 'Alliage Co-Cr pour Châssis métallique (CCP)', 
            manufacturer: 'Bego (Germany) / VeraPDS', 
            ce: 'CE542249', 
            iso: 'ISO 22674', 
            lot: 'Co-cr-20090301',
            composition: 'Cobalt-Chrome haute résistance'
        }
    },

    // ===== CÉRAMO-MÉTALLIQUE (CCM / PFM) =====
    PFM: {
        metal: { 
            name: 'Alliage Co-Cr (Argeloy N.P)', 
            manufacturer: 'Argen (US)', 
            ce: 'CE542249', 
            iso: 'ISO 22674', 
            lot: 'Co-cr-20090301' 
        },
        porcelain: {
            manufacturer: 'VITA (VMK 95, Germany)',
            ce: 'CE0124',
            iso: 'ISO 6872',
            defaultLot: '77510',
            shades: {
                A1: { lot: '97311' },
                A2: { lot: '77510' },
                A3: { lot: '94130' },
                'A3.5': { lot: '80150' },
                A4: { lot: '74130' },
                B1: { lot: '97311' },
                B2: { lot: '77510' },
                B3: { lot: '94130' },
                C1: { lot: '74571' },
                C2: { lot: '77510' },
                C3: { lot: '94130' },
            }
        }
    },

    // ===== E.MAX (Disilicate de Lithium) =====
    EMAX: {
        disc: { 
            name: 'Disque / Bloc IPS e.max CAD', 
            manufacturer: 'Ivoclar (Liechtenstein)', 
            ce: 'CE0123', 
            iso: 'ISO 6872', 
            lot: '203CH5' 
        },
        porcelain: { 
            name: 'Céramique IPS e.max Ceram', 
            manufacturer: 'Ivoclar (Liechtenstein)', 
            ce: 'CE0123', 
            iso: 'ISO 6872', 
            lot: '940' 
        }
    },

    // ===== RÉSINE ACRYLIQUE (Prothèse amovible & Selle de CCP) =====
    ACRYLIC: {
        resin: { 
            name: 'Résine thermopolymérisable (QC-20)', 
            manufacturer: 'Dentsply (US)', 
            ce: 'CE1907', 
            iso: 'ISO 20795-1', 
            lot: '30.02K199.10.3K' 
        },
        teeth: { 
            name: 'Dents résine multicouches', 
            manufacturer: 'Yamahachi Dental (Japan)', 
            ce: 'CE0124', 
            iso: 'ISO 22112', 
            lot: '97311' 
        }
    },

    // ===== PROTHÈSE FLEXIBLE (Valplast / TCS) =====
    FLEXIBLE: {
        resin: { 
            name: 'Polyamide flexible (TCS Unbreakable)', 
            manufacturer: 'TCS (US)', 
            ce: 'CE1907', 
            iso: 'ISO 20795-1', 
            lot: '75120519' 
        },
        teeth: { 
            name: 'Dents résine', 
            manufacturer: 'Yamahachi Dental (Japan)', 
            ce: 'CE0124', 
            iso: 'ISO 22112', 
            lot: '97311' 
        }
    },

    // ===== GOUTTIÈRES (Bruxisme / Blanchiment / Night Guard) =====
    NIGHT_GUARD: {
        material: { 
            name: 'Matériau thermoformé (Erkolo-pro)', 
            manufacturer: 'Erkodent (Germany)', 
            ce: 'CE0197', 
            iso: 'ISO 20795-2', 
            lot: '11794' 
        }
    },

    // ===== PMMA (Dent / Couronne Provisoire) =====
    PMMA: {
        disc: { 
            name: 'Disque PMMA usiné', 
            manufacturer: 'Aidite', 
            ce: 'CE0197', 
            iso: 'ISO 20795-1', 
            lot: '35545400' 
        }
    },

    // ===== COMPOSITE (Inlay / Onlay Ceramage) =====
    COMPOSITE: {
        material: { 
            name: 'Composite micro-hybride Ceramage', 
            manufacturer: 'SHOFU (Japan)', 
            ce: 'CE0123', 
            iso: 'ISO 4049' 
        },
        shades: {
            A1: { lot: '122155' },
            A2: { lot: '092269' },
            A3: { lot: '092269' },
            'A3.5': { lot: '112115' },
            B1: { lot: '072141' },
        },
        defaultLot: '092269'
    },

    // ===== IMPLANTS / EMBASES & PILIERS TITANE =====
    TITANIUM: {
        pillar: { 
            name: 'Pilier / Embase Titane Grade V', 
            manufacturer: 'NEO / Argen', 
            ce: 'CE0120', 
            iso: 'ISO 5832-3', 
            lot: 'TI-210408' 
        }
    }
};

/**
 * Normalise un texte pour faciliter la recherche de mots-clés
 */
const normalizeText = (text = '') => {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Supprime les accents
        .replace(/[_\-\/,]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};

/**
 * Génère la liste des lots et normes associés à un travail prothétique.
 * 
 * @param {string} category - Catégorie de produit (ex: "TOUT CÉRAMIQUE, CFAO", "STELLITE", "INLAY CORE ET COURONNE COULÉE")
 * @param {string} productName - Nom du produit (ex: "Full Zircone Monochrome", "Stellite CoCr finition directe", "Couronne coulée CoCr")
 * @param {string} shade - Teinte éventuelle (ex: "A2", "A3", "1D", "B1")
 * @param {string} notes - Remarques techniques ou notes de travail éventuelles
 * @returns {Array<{label: string, value: string, iso: string}>}
 */
export const getLotNumbers = (category = '', productName = '', shade = '', notes = '') => {
    // Si le 2ème argument est court et sans espace, c'est probablement une teinte passée par erreur d'appel historique
    if (typeof productName === 'string' && productName.length <= 4 && !productName.includes(' ') && !shade) {
        shade = productName;
        productName = '';
    }

    const normCat = normalizeText(category);
    const normProd = normalizeText(productName);
    const normNotes = normalizeText(notes);
    const combined = `${normCat} ${normProd} ${normNotes}`;
    const shadeKey = (shade || '').toUpperCase().trim();
    const lots = [];

    // Helper pour ne pas dupliquer le même label
    const addLot = (label, value, iso) => {
        if (!lots.some(l => l.label === label)) {
            lots.push({ label, value, iso });
        }
    };

    // =========================================================================
    // 0. EXCLUSION STRICTE : MODÈLES 3D & AUXILIAIRES DE LABORATOIRE
    // =========================================================================
    const isAuxiliaryOnly = (
        (normProd.includes('model 3d') || normProd.includes('modele 3d') || normProd.includes('arcade complete') || normProd.includes('cire d occlusion') || normProd.includes('porte empreinte') || normProd.includes('p.e.i') || normProd.includes('pei'))
        && !normProd.includes('zircon') && !normProd.includes('stellite') && !normProd.includes('ccp') && !normProd.includes('couronne')
    );
    if (isAuxiliaryOnly) {
        return [];
    }

    // =========================================================================
    // 1. CHÂSSIS COULÉ PARTIEL (CCP) / STELLITE / CHÂSSIS MÉTALLIQUE
    // =========================================================================
    const isCCP = (
        normCat.includes('stellite') ||
        normProd.includes('ccp') ||
        normProd.includes('stellite') ||
        normProd.includes('chassis') ||
        normProd.includes('framework') ||
        normNotes.includes('ccp') ||
        normNotes.includes('stellite')
    );

    if (isCCP) {
        const cocr = materialLotData.COCR_FRAMEWORK.alloy;
        addLot('Lot Alliage Co-Cr Châssis (ISO 22674 / UE)', `${cocr.lot} (${cocr.manufacturer}, ${cocr.ce} - ${cocr.iso})`, cocr.iso);

        // Si ce n'est PAS une plaque nue / essayage cire seul, inclure la résine et les dents
        const isBareMetalOnly = normProd.includes('plaque nue') || (normProd.includes('essayage') && !normProd.includes('finition'));
        if (!isBareMetalOnly) {
            const acr = materialLotData.ACRYLIC;
            addLot('Lot Résine de selle (ISO 20795-1 / UE)', `${acr.resin.lot} (${acr.resin.manufacturer}, ${acr.resin.ce} - ${acr.resin.iso})`, acr.resin.iso);
            addLot('Lot Dents résine (ISO 22112 / UE)', `${acr.teeth.lot} (${acr.teeth.manufacturer}, ${acr.teeth.ce} - ${acr.teeth.iso})`, acr.teeth.iso);
        }
        return lots;
    }

    // =========================================================================
    // 2. COURONNE COULÉE (FMC) / INLAY CORE / CLAVETTE / AILETTES
    // 100% Métal Co-Cr - AUCUNE PORCELAINE NI CÉRAMIQUE
    // =========================================================================
    const isCastMetal = (
        normProd.includes('couronne coulee') ||
        normProd.includes('coulee') ||
        normProd.includes('inlay core') ||
        normProd.includes('clavette') ||
        normProd.includes('ailette') ||
        normProd.includes('fmc') ||
        (normCat.includes('inlay core') && !normProd.includes('ceram')) ||
        (normProd.includes('metal cocr') && !normProd.includes('ceram')) ||
        (normProd.includes('armature cocr') && !normProd.includes('finition'))
    );

    if (isCastMetal) {
        const metal = materialLotData.COCR_CROWN.alloy;
        addLot('Lot Alliage Co-Cr (ISO 22674 / UE)', `${metal.lot} (${metal.manufacturer}, ${metal.ce} - ${metal.iso})`, metal.iso);
        if (combined.includes('implant') || combined.includes('transvis') || combined.includes('transfix') || combined.includes('pilier')) {
            const tit = materialLotData.TITANIUM.pillar;
            addLot('Lot Embase / Pilier Titane (ISO 5832-3 / UE)', `${tit.lot} (${tit.manufacturer}, ${tit.ce} - ${tit.iso})`, tit.iso);
        }
        return lots;
    }

    // =========================================================================
    // 3. FULL ZIRCONE (Monochrome, Multilayer, Translucent, Full Zirconia)
    // Zircone monolithique pleine masse - AUCUNE CÉRAMIQUE DE STRATIFICATION !
    // =========================================================================
    const isFullZirconia = (
        normProd.includes('full zircon') ||
        normProd.includes('zircone mono') ||
        normProd.includes('zircone multi') ||
        normProd.includes('multilayer') ||
        normProd.includes('translucent') ||
        normNotes.includes('full zircon')
    );

    // =========================================================================
    // 4. ZIRCONE STRATIFIÉE (PFZ / Layered Zirconia)
    // =========================================================================
    const isStratifiedZirconia = (
        (normProd.includes('zircon') || normNotes.includes('zircon')) &&
        (normProd.includes('strat') || normNotes.includes('strat') || normProd.includes('pfz'))
    );

    if (isFullZirconia && !isStratifiedZirconia) {
        const zirc = materialLotData.ZIRCONIA.disc;
        addLot('Lot Disque Zircone (ISO 6872 / UE)', `${zirc.lot} (${zirc.manufacturer}, ${zirc.ce} - ${zirc.iso})`, zirc.iso);
        if (combined.includes('implant') || combined.includes('transvis') || combined.includes('transfix') || combined.includes('pilier') || combined.includes('scelle')) {
            const tit = materialLotData.TITANIUM.pillar;
            addLot('Lot Embase / Pilier Titane (ISO 5832-3 / UE)', `${tit.lot} (${tit.manufacturer}, ${tit.ce} - ${tit.iso})`, tit.iso);
        }
        return lots;
    }

    if (isStratifiedZirconia) {
        const zirc = materialLotData.ZIRCONIA.disc;
        const noritake = materialLotData.NORITAKE_PORCELAIN;
        addLot('Lot Disque Zircone (ISO 6872 / UE)', `${zirc.lot} (${zirc.manufacturer}, ${zirc.ce} - ${zirc.iso})`, zirc.iso);
        
        const porcLot = noritake.shades[shadeKey]?.lot || noritake.defaultLot;
        const shadeDisplay = (shadeKey && shadeKey !== '-') ? ` - Teinte ${shadeKey}` : '';
        addLot('Lot Céramique Noritake (ISO 6872 / UE)', `${porcLot} (${noritake.manufacturer}, ${noritake.ce} - ${noritake.iso}${shadeDisplay})`, noritake.iso);
        
        if (combined.includes('implant') || combined.includes('transvis') || combined.includes('transfix') || combined.includes('pilier') || combined.includes('scelle')) {
            const tit = materialLotData.TITANIUM.pillar;
            addLot('Lot Embase / Pilier Titane (ISO 5832-3 / UE)', `${tit.lot} (${tit.manufacturer}, ${tit.ce} - ${tit.iso})`, tit.iso);
        }
        return lots;
    }

    // Autres travaux Zircone génériques
    if (normProd.includes('zircon') || (normCat.includes('tout ceramique') && !normProd.includes('emax') && !normProd.includes('composite'))) {
        const zirc = materialLotData.ZIRCONIA.disc;
        addLot('Lot Disque Zircone (ISO 6872 / UE)', `${zirc.lot} (${zirc.manufacturer}, ${zirc.ce} - ${zirc.iso})`, zirc.iso);
        if (normProd.includes('ceram') || normProd.includes('finition') || normProd.includes('strat')) {
            const noritake = materialLotData.NORITAKE_PORCELAIN;
            const porcLot = noritake.shades[shadeKey]?.lot || noritake.defaultLot;
            const shadeDisplay = (shadeKey && shadeKey !== '-') ? ` - Teinte ${shadeKey}` : '';
            addLot('Lot Céramique Noritake (ISO 6872 / UE)', `${porcLot} (${noritake.manufacturer}, ${noritake.ce} - ${noritake.iso}${shadeDisplay})`, noritake.iso);
        }
        if (combined.includes('implant') || combined.includes('transvis') || combined.includes('transfix') || combined.includes('pilier') || combined.includes('scelle')) {
            const tit = materialLotData.TITANIUM.pillar;
            addLot('Lot Embase / Pilier Titane (ISO 5832-3 / UE)', `${tit.lot} (${tit.manufacturer}, ${tit.ce} - ${tit.iso})`, tit.iso);
        }
        return lots;
    }

    // =========================================================================
    // 5. CÉRAMO-MÉTALLIQUE (CCM / PFM / Richmond / Céramique sur implant)
    // =========================================================================
    const isCCM = (
        !normProd.includes('zircon') &&
        !normProd.includes('emax') &&
        !normProd.includes('composite') &&
        !normProd.includes('pmma') &&
        !normProd.includes('barre titane') &&
        (
            normProd.includes('ccm') ||
            normProd.includes('ceramique sur metal') ||
            normProd.includes('richmond') ||
            normProd.includes('pfm') ||
            normProd.includes('ceramo metallique') ||
            normProd.includes('ceramo metal') ||
            normProd.includes('ceramometallique') ||
            normProd.includes('ceramique sur implant') ||
            normProd.includes('epaulement ceramique') ||
            normProd.includes('ceramique rose') ||
            (normCat.includes('ccm') && !normProd.includes('provisoire')) ||
            (normCat.includes('implant') && (
                normProd.includes('ceramo') ||
                normProd.includes('ceramique') ||
                normProd.includes('finition') ||
                normProd.includes('armature')
            ))
        )
    );

    if (isCCM) {
        const pfm = materialLotData.PFM;
        addLot('Lot Alliage Co-Cr (ISO 22674 / UE)', `${pfm.metal.lot} (${pfm.metal.manufacturer}, ${pfm.metal.ce} - ${pfm.metal.iso})`, pfm.metal.iso);
        
        const isArmatureOnly = normProd.includes('armature') && !normProd.includes('finition');
        if (!isArmatureOnly || normNotes.includes('finition') || (shadeKey && shadeKey !== '-')) {
            const porcLot = pfm.porcelain.shades[shadeKey]?.lot || pfm.porcelain.defaultLot;
            const shadeDisplay = (shadeKey && shadeKey !== '-') ? ` - Teinte ${shadeKey}` : '';
            addLot('Lot Porcelaine Vita (ISO 6872 / UE)', `${porcLot} (${pfm.porcelain.manufacturer}, ${pfm.porcelain.ce} - ${pfm.porcelain.iso}${shadeDisplay})`, pfm.porcelain.iso);
        }

        if (combined.includes('implant') || combined.includes('transvis') || combined.includes('transfix') || combined.includes('pilier') || combined.includes('scelle')) {
            const tit = materialLotData.TITANIUM.pillar;
            addLot('Lot Embase / Pilier Titane (ISO 5832-3 / UE)', `${tit.lot} (${tit.manufacturer}, ${tit.ce} - ${tit.iso})`, tit.iso);
        }
        return lots;
    }

    // =========================================================================
    // 6. E.MAX (Couronne, Facette, Inlay/Onlay Emax, Disilicate)
    // =========================================================================
    if (normProd.includes('emax') || normProd.includes('e.max') || normProd.includes('disilicate') || normCat.includes('emax')) {
        const emax = materialLotData.EMAX;
        addLot('Lot Disque / Bloc E.max (ISO 6872 / UE)', `${emax.disc.lot} (${emax.disc.manufacturer}, ${emax.disc.ce} - ${emax.disc.iso})`, emax.disc.iso);
        if (normProd.includes('strat') || normProd.includes('finition ceramique')) {
            addLot('Lot Porcelaine E.max (ISO 6872 / UE)', `${emax.porcelain.lot} (${emax.porcelain.manufacturer}, ${emax.porcelain.ce} - ${emax.porcelain.iso})`, emax.porcelain.iso);
        }
        if (combined.includes('implant') || combined.includes('transvis') || combined.includes('transfix') || combined.includes('pilier') || combined.includes('scelle')) {
            const tit = materialLotData.TITANIUM.pillar;
            addLot('Lot Embase / Pilier Titane (ISO 5832-3 / UE)', `${tit.lot} (${tit.manufacturer}, ${tit.ce} - ${tit.iso})`, tit.iso);
        }
        return lots;
    }

    // =========================================================================
    // 7. COMPOSITE (Inlay / Onlay Composite)
    // =========================================================================
    if (normProd.includes('composite')) {
        const comp = materialLotData.COMPOSITE;
        const shadeLot = comp.shades[shadeKey]?.lot || comp.defaultLot;
        addLot('Lot Composite (ISO 4049 / UE)', `${shadeLot} (${comp.material.manufacturer}, ${comp.material.ce} - ${comp.material.iso})`, comp.material.iso);
        return lots;
    }

    // =========================================================================
    // 8. PROVISOIRES & PMMA (Couronnes / Dents provisoires)
    // =========================================================================
    if (normProd.includes('provisoire') || normProd.includes('pmma') || normProd.includes('provisional')) {
        const pmma = materialLotData.PMMA;
        addLot('Lot Disque PMMA (ISO 20795-1 / UE)', `${pmma.disc.lot} (${pmma.disc.manufacturer}, ${pmma.disc.ce} - ${pmma.disc.iso})`, pmma.disc.iso);
        return lots;
    }

    // =========================================================================
    // 9. VALPLAST / PROTHÈSE FLEXIBLE (Polyamide TCS Unbreakable)
    // =========================================================================
    if (normProd.includes('valplast') || normProd.includes('flexible') || normProd.includes('nylon')) {
        const flx = materialLotData.FLEXIBLE;
        addLot('Lot Base Flexible Polyamide (ISO 20795-1 / UE)', `${flx.resin.lot} (${flx.resin.manufacturer}, ${flx.resin.ce} - ${flx.resin.iso})`, flx.resin.iso);
        addLot('Lot Dents résine (ISO 22112 / UE)', `${flx.teeth.lot} (${flx.teeth.manufacturer}, ${flx.teeth.ce} - ${flx.teeth.iso})`, flx.teeth.iso);
        return lots;
    }

    // =========================================================================
    // 10. PROTHÈSE ADJOINTE RÉSINE (Complète / Partielle résine)
    // =========================================================================
    const isAcrylicDenture = (
        normCat.includes('prothese complete') ||
        normCat.includes('prothese partielle') ||
        normProd.includes('prothese complete') ||
        normProd.includes('prothese 1') ||
        normProd.includes('prothese 6') ||
        normProd.includes('appareil resine') ||
        normProd.includes('reparation appareil') ||
        normProd.includes('adjonction dent') ||
        normProd.includes('finition prothese resine') ||
        normProd.includes('denture') ||
        normProd.includes('rebasage')
    );

    if (isAcrylicDenture) {
        const acr = materialLotData.ACRYLIC;
        addLot('Lot Résine Acrylique (ISO 20795-1 / UE)', `${acr.resin.lot} (${acr.resin.manufacturer}, ${acr.resin.ce} - ${acr.resin.iso})`, acr.resin.iso);
        if (!normProd.includes('rebasage') && !normProd.includes('grille')) {
            addLot('Lot Dents résine (ISO 22112 / UE)', `${acr.teeth.lot} (${acr.teeth.manufacturer}, ${acr.teeth.ce} - ${acr.teeth.iso})`, acr.teeth.iso);
        }
        return lots;
    }

    // =========================================================================
    // 11. GOUTTIÈRES (Bruxisme, Blanchiment, Night Guard)
    // =========================================================================
    if (normCat.includes('gouttiere') || normProd.includes('gouttiere') || normProd.includes('bruxisme') || normProd.includes('blanchiment') || normProd.includes('night guard')) {
        const ng = materialLotData.NIGHT_GUARD.material;
        addLot('Lot Matériau Gouttière Thermoformé (ISO 20795-2 / UE)', `${ng.lot} (${ng.manufacturer}, ${ng.ce} - ${ng.iso})`, ng.iso);
        return lots;
    }

    // =========================================================================
    // 12. IMPLANTS / PILIERS TITANE / BARRES TITANE / CALCINABLES
    // =========================================================================
    const isPureImplantPillar = (
        normProd.includes('pilier') ||
        normProd.includes('barre titane') ||
        /\bvis\b/.test(normProd) ||
        normProd.includes('titane') ||
        normProd.includes('calcinable') ||
        normProd.includes('faux moignon') ||
        (normCat.includes('implant') && !normProd.includes('zircon') && !normProd.includes('ceram'))
    );

    if (isPureImplantPillar) {
        const tit = materialLotData.TITANIUM.pillar;
        addLot('Lot Titane Grade V (ISO 5832-3 / UE)', `${tit.lot} (${tit.manufacturer}, ${tit.ce} - ${tit.iso})`, tit.iso);

        if (normProd.includes('resine') || normProd.includes('complet')) {
            const acr = materialLotData.ACRYLIC;
            addLot('Lot Résine Acrylique (ISO 20795-1 / UE)', `${acr.resin.lot} (${acr.resin.manufacturer}, ${acr.resin.ce} - ${acr.resin.iso})`, acr.resin.iso);
            addLot('Lot Dents résine (ISO 22112 / UE)', `${acr.teeth.lot} (${acr.teeth.manufacturer}, ${acr.teeth.ce} - ${acr.teeth.iso})`, acr.teeth.iso);
        }

        if (normProd.includes('calcinable') || normProd.includes('faux moignon')) {
            const metal = materialLotData.COCR_CROWN.alloy;
            addLot('Lot Alliage Co-Cr (ISO 22674 / UE)', `${metal.lot} (${metal.manufacturer}, ${metal.ce} - ${metal.iso})`, metal.iso);
        }

        return lots;
    }

    return lots;
};

/**
 * Calcule dynamiquement le texte des normes applicables selon les lots utilisés
 * pour une parfaite conformité Règlement Européen (UE) 2017/745 (MDR).
 * 
 * @param {Array<{iso?: string}>} lots - Liste des lots retenus
 * @returns {string} Phrase de conformité avec les normes exactes
 */
export const getApplicableStandardsText = (lots = []) => {
    const isoSet = new Set();
    
    lots.forEach(lot => {
        if (lot.iso) isoSet.add(lot.iso);
    });

    const standardLabels = [];
    if (isoSet.has('ISO 6872')) standardLabels.push('ISO 6872 (Céramiques et Zircones)');
    if (isoSet.has('ISO 22674')) standardLabels.push('ISO 22674 (Alliages dentaires métalliques Co-Cr)');
    if (isoSet.has('ISO 20795-1')) standardLabels.push('ISO 20795-1 (Polymères pour bases de prothèses résines)');
    if (isoSet.has('ISO 22112')) standardLabels.push('ISO 22112 (Dents artificielles pour prothèses)');
    if (isoSet.has('ISO 20795-2')) standardLabels.push('ISO 20795-2 (Matériaux pour gouttières)');
    if (isoSet.has('ISO 4049')) standardLabels.push('ISO 4049 (Composites dentaires)');
    if (isoSet.has('ISO 5832-3')) standardLabels.push('ISO 5832-3 (Implants et piliers en titane)');

    if (standardLabels.length === 0) {
        return 'aux normes européennes et internationales applicables aux dispositifs médicaux sur mesure.';
    }

    return `aux normes internationales applicables (notamment ${standardLabels.join(', ')}).`;
};

/**
 * Génère le texte formaté des lots pour l'affichage textuel brut.
 * @param {string} category 
 * @param {string} productName 
 * @param {string} shade 
 * @param {string} notes
 * @returns {string} Texte formaté des numéros de lot
 */
export const getLotNumbersText = (category, productName, shade, notes = '') => {
    const lots = getLotNumbers(category, productName, shade, notes);
    if (lots.length === 0) return '';
    return lots.map(l => `${l.label} : ${l.value}`).join('\n');
};

export default materialLotData;
